import {Injectable} from '@angular/core';

import {Observable} from "rxjs/Observable";
import {Observer} from "rxjs/Observer";

import {Facebook} from "@ionic-native/facebook";
import {FacebookService} from "ngx-facebook";

import {Util} from "../app/util";
import {CONFIG} from "../app/config";
import {
    TAction,
    TProfileSexo,
    TProfileFlag,
    TReceitaNumber,
    TReceitaFlag, TContatoTipo, TFollowup, TShareupTipo,
} from "../app/enum";

import {DataService} from "../providers/data-service";
import {ProfileService} from "../providers/profile-service";
import {LogadoService} from "../providers/logado-service";
import {AFTER_LOGOUT} from "../app/import";
import {NavRepository} from "./nav-repository";
import {ModalActionPage} from "../pages/sync/modal-action/modal-action";

import {ContatoMenuPage} from "../pages/sync/contato-menu/contato-menu";
import {CallNumber} from "@ionic-native/call-number";
import {Contact, ContactField, ContactFindOptions, ContactName, Contacts} from "@ionic-native/contacts";
import {LaunchNavigator, LaunchNavigatorOptions} from "@ionic-native/launch-navigator";
import {MessageService} from "../providers/message-service";
import {InAppBrowser} from '@ionic-native/in-app-browser';
import {SocialSharing} from '@ionic-native/social-sharing';

@Injectable()
export class ProfileRepository {

    constructor(public util: Util, public dataService: DataService, public messageService: MessageService,
                public navRepository: NavRepository,
                public logadoService: LogadoService,
                public profileService: ProfileService,
                public fb: Facebook, public fbWeb: FacebookService,
                public callNumber: CallNumber,
                public contacts: Contacts,
                public inAppBrowser: InAppBrowser,
                public launchNavigator: LaunchNavigator,
                private socialSharing: SocialSharing) {

        //Facebook Init
        if (!this.util.nativeApp()) this.fbWeb.init(CONFIG.iface());

    }

    //profileCria(rnid)
    profileFind(rnid: string, rntp: 'CPF' | 'CNPJ', profileCtrl: any = null, ghosterID: number = 0, profileSpot: boolean = false, confirm: boolean = false, accept: any = null, monitorBool: boolean = false): Observable<any> {

        return Observable.create((observer: Observer<any>) => {

            let mask = (rntp == 'CPF' ? '000.000.000-00' : '00.000.000/0000-00');
            let none = !rnid || !profileSpot;

            let onOkey = (okey, that, data) => {

                rnid = (rnid ? rnid : okey.inputf.text);
                //rnid = this.util.formatDOC(rnid);
                //desenvolver formatDOC

                if (!okey.perfilfnd) {

                    //Finded Profile
                    let loading = this.util.loadingDots();
                    loading.present();

                    //#DEVELOP monitor local para checkin cadastrando cliente!
                    let request;
                    if ( monitorBool) request = this.util.monitorDesk(true, 'DESK-Profile', 0, '&ProfileRnid=' + rnid, TAction.acFind, null, 10000)
                    if (!monitorBool) request = this.profileService.profile(TAction.acFind, 0, null, '&ProfileRnid=' + rnid)

                    request
                        .finally(() => loading.dismiss())
                        .subscribe(
                            data => {

                                let cnpj = this.util.validaCNPJ(rnid);
                                
                                let profileNovo = (!data || !data.Profiles || data.Profiles.length == 0);
                                let empresaNova = (cnpj && data && data.Profiles && data.Profiles.length == 1 && data.Profiles[0].Profile && !data.Profiles[0].Profile.ProfileID ? data.Profiles[0] : null);

                                if (profileNovo || empresaNova) {

                                    if (!profileCtrl) this.util.alertSimply('Perfil não encontrado');

                                    if (profileCtrl) {
                                        if (that && none) that.dismiss();

                                        let reid = (empresaNova ? empresaNova.Profile.ProfileReid : '');
                                        let nome = (empresaNova ? empresaNova.Profile.ProfileNome : '');
                                        let name = (empresaNova ? empresaNova.Profile.ProfileName : '');
                                        let born = (empresaNova ? empresaNova.Profile.ProfileBorn || '2000-01-01' : '');

                                        let profile = {GhosterID: ghosterID, ProfileID: 0, ProfileRnid: rnid, ProfileReid: reid, ProfileNome: nome, ProfileName: name, ProfileBorn: born, ProfileSexo: TProfileSexo.psNenhum, ProfileFlag: TProfileFlag.pfGhost, ProfileCnpj: cnpj};
                                        let contatos = (empresaNova ? (empresaNova.Contatos || []) : []);
                                        let addresss = (empresaNova ? (empresaNova.Addresss || []) : []);
                                        let object = {etapa: 1, monitorBool: monitorBool, profileSpot: profileSpot, rootile: {Profile: profile, Contatos: contatos, Addresss: addresss, Accounts: []}};

                                        this.util.modalopen(profileCtrl, 'alto', false, object)
                                            .finally(() => observer.complete())
                                            .subscribe(data => observer.next(data));

                                    }

                                    return;

                                }

                                //Não vem, então adiciona o que pesquisou
                                //#BORN Coloquei para usar no profileBorn() - Nasc confirma!
                                data.Profiles[0].ProfileRnid = rnid;

                                if (confirm) {
                                    okey.perfilfnd = data.Profiles[0];
                                    okey.corcor = 'CorRoxa';
                                    okey.titulo = okey.perfilfnd.ProfileShow;
                                    okey.resumo = 'Adicionar ' + okey.perfilfnd.ProfileShow + '?';
                                    okey.imagem = (rntp == 'CNPJ' ? null : okey.perfilfnd.ProfileFace);
                                    okey.action.name = 'Confirmar';
                                    return;
                                }

                                if (accept) {
                                    let modal = CONFIG.modalinfo(this.util, accept, onOkey);
                                    modal.perfilfnd = data.Profiles[0];
                                    okey.linhas = [];
                                    this.util.populateObj(okey, modal, ['onOkey'], true);
                                    return;
                                }

                                if (that) that.dismiss();
                                observer.next(data.Profiles[0]);
                                observer.complete();

                            },
                            erro => {

                                this.util.alertResult(erro);

                            });

                    return;
                }

                if (okey.perfilfnd) {
                    if (that) that.dismiss();
                    observer.next(okey.perfilfnd);
                    observer.complete();
                }

            };

            if (rnid) {
                onOkey({perfilfnd: null}, null, null);
                return;
            }

            let objectData = {modalinfo: CONFIG.modalinfo(this.util, 'profilefnd', onOkey, null, false, mask)};
            this.util.modalopen(ModalActionPage, 'alto', false, objectData).subscribe();

        });

    }

    birthday(component: any, checkDocumento: boolean, profile: any, logadoTeam: boolean = false): Observable<any> {

        return Observable.create((observer: Observer<any>) => {

            let onNext = (data) => {
                observer.next(data);
                observer.complete();
            }

            let onErro = () => {
                //NAO PODE TER ERRO PARA NAO OBRIGAR A COLOCAR O "SUBSCRIBE ERR"
                //observer.error({});
                observer.complete();
            }


            //Aprovado (cadastro esta okey)
            if (profile.ReceitaFlag == TReceitaFlag.rsAprovado) {
                onNext({});
                return;
            }


            //Negado (login já nao deixa o cara logar)
            if (profile.ReceitaFlag == TReceitaFlag.rsNegado && profile.ReceitaCode != TReceitaNumber.rfReceitaNascido && !checkDocumento) {
                onNext({});
                return;
            }


            let rootile = {Profile: profile};

            //Cadastro (etapa pergunta data de nascimento)
            this.util.modalopen(component, 'wide', false, {etapa: 6, rootile: rootile, copyile: this.util.deepCopy(rootile)}).subscribe(
                data => {

                  //if (data && profile.ReceitaFlag != TReceitaFlag.rsNegado) onNext(data);
                    if (data && profile.ReceitaFlag == TReceitaFlag.rsAprovado) onNext(data);
                    else if (logadoTeam) this.util.alertQuestion('Receita Federal', profile.ReceitaText, 'Continuar', () => onNext(data), false, true, null, () => onErro());
                    else onErro();

                });

        });

    }

    zipcity(FIX_CIRCULAR_ListingMenuPage: any, ziploads: any, event?): Observable<any> {

        return Observable.create((observer: Observer<any>) => {

            let alignL = {type: 'init', text: '', show: 'Zone', info: '', color: ''};
            let alignC = {type: 'text', text: '', show: 'City', info: '', color: ''};
            let alignR = {type: 'none', text: '', show: '', info: '', color: ''};

            let onShow = (show, that, limitPage, reload) => {
                ziploads = ziploads.filter(city => city.Pkey > 100);
                that.parseArray(ziploads, null, 0, 0, false, null, 'zero');
            };

            let onOkuy = (okey, that, line, click, event) => {
                observer.next(line);
                that.dismiss();
            };

            let modalshow = CONFIG.listingForm('Cidade', onShow, onOkuy, alignL, alignC, alignR, null, null, true);
            let objectData = {perfil: null, modalshow: modalshow};

            this.util.modalopen(FIX_CIRCULAR_ListingMenuPage, 'alto', false, objectData, {ev: event}).subscribe(data => observer.complete());

        })

    }

    logbye(navCtrl: any) {

        this.logadoService.logout();
        this.navRepository.afterLogout(navCtrl, AFTER_LOGOUT).subscribe();

    }

    logout(navCtrl: any, logoutAsk: boolean = true, devicerID: number = 0, devicerThis: boolean = true): Observable<any> {

        return Observable.create((observer: Observer<any>) => {

            let logado = this.logadoService.getAuth();
            if (!logado) return;


            //Fake-Ghost - Deslogar
            if (!logoutAsk) {
                if (devicerThis) this.logbye(navCtrl);

                observer.next({});
                observer.complete();

                return;
            }

            devicerID = (devicerID ? devicerID : logado.Profile.DevicerID);

            //Logout Ask
            let onConfir = () => {

                let loading = this.util.loadingDots();
                loading.present();

                this.profileService.devicer(TAction.acSair, devicerID, logado.Profile.ProfileID)
                    .finally(() => loading.dismiss())
                    .subscribe(
                        data => {

                            if (devicerThis) this.logbye(navCtrl);

                            observer.next(data);
                            observer.complete();

                        },
                        erro => {

                            this.util.alertResult(erro);

                            observer.error(erro);
                            observer.complete();

                        });
            };

            let alerta = (devicerThis ? 'Deseja sair agora?' : 'Deseja sair desse dispositivo?');
            let cssClass = (devicerThis ? 'alert-danger' : 'alert-alert');
            this.util.alertQuestion('Logout', alerta, 'Confirmar', () => onConfir(), false, false, cssClass);

        });

    }






    //SHARELINK
    sharedyLink(sharedyTipo: TShareupTipo, sharedyNome, parapage, params) {

        let develop = false;
        let https = (develop ? 'https://localhost:8100' : CONFIG.paths.httpLorean);
        let short = (develop ? 'https://support.lorean.com.br' : 'https://lorean.app');

        https = https + '?page=' + parapage + '&' + params;
        let object = {Shareups: [{ShareupHttp: https, ShareupJson: ''}]};

        let loading = this.util.loadingDots();
        loading.present();

        this.profileService.shareup(TAction.acSave, '', sharedyTipo, object)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    if (!this.util.nativeApp()) {
                        this.util.open(https, '_blank', '');
                        return;
                    }

                    short = short + '/' + data.Shareups[0].ShareupCode;
                    this.socialSharing.share(short, sharedyNome);

                },
                erro => this.util.alertResult(erro)
            );

    }

    contatoOpen(contato: any, configure: boolean, contact: any = null, onLove: Function = null) {

        if (!contato) return;

        let logado = this.logadoService.getAuth();
        let loghave = (!logado || logado.Contatos.find(ctato => ctato.ContatoRede == contato.ContatoRede));

        let native = this.util.nativeApp();

        if (configure && !loghave && contato.ContatoRede != TContatoTipo.coTube) {
            let titulo = 'NOME DA REDE, FACE, INSTA, ...';
            let alerta = 'Para você visualizar configure a sua conta.';
            this.util.alertQuestion(titulo, alerta, 'Continuar', () => {
                let object = {etapa: 1, rootile: logado, contato: contato};
                this.util.modalopen(ContatoMenuPage, 'alto', false, object).subscribe();
            });
            return;
        }


        //ContatoOpen
        let onOpen = (link) => {
            //let target = native ? '_system' : '_blank';
            if (!native) this.util.open(link, '_blank', '');
            if ( native) this.inAppBrowser.create(link, '_system');
        };

        if (contato.ContatoRede == TContatoTipo.coFace) {
            let appurl = native ? 'fb://profile/' : 'https://www.fb.com/';
            //appurl = appurl + '/app_scoped_user_id/' + contato.ContatoLink;
            if ( contato.ContatoCode) onOpen(appurl + contato.ContatoCode);
            if (!contato.ContatoCode) onOpen(appurl + contato.ContatoUser);
        }

        if (contato.ContatoRede == TContatoTipo.coInst) {
            let appurl = native ? 'instagram://user?username=' : 'https://www.instagram.com/';
            onOpen(appurl + this.util.textReplace(contato.ContatoUser, '@', ''));
        }

        if (contato.ContatoRede == TContatoTipo.coTube) {
            onOpen('https://www.youtube.com/user/' + contato.ContatoUser);
        }

        if (contato.ContatoRede == TContatoTipo.coChip) {

            let phonecat = '55' + contato.ContatoUser.replace('-', '').replace('(', '').replace(')', '').replace(' ', '');

            /** OPEN **/
            let appurl = 'https://api.whatsapp.com/send?phone=' + phonecat; //nativeApp() ? 'whatsapp://send?text=&phone=55'
            let buttons: Array<any> = [];
            if (onLove)  buttons.push({text: 'Contatinho', handler: () => onLove()});
                         buttons.push({text: 'Whatsapp',   handler: () => onOpen(appurl)});
            if (native)  buttons.push({text: 'Ligação',    handler: () => this.callfone(contato.ContatoUser)});
            if (contact) buttons.push({text: 'Cadastrar',  handler: () => this.contatoBook(contact, contato)});
            this.util.sheetOpen(buttons, 'CONTATO');

        }

    }

    callfone(numero: string) {

        //Nao é celular nao liga
        if (!this.util.nativeApp()) {
            this.util.toastSimply('Use no app para ligar');
            return;
        }

        //Ligar agora
        if (this.callNumber.isCallSupported()) {
            this.callNumber.callNumber('0' + numero, true)
                .then(then => console.log('Launched dialer!', then))
                .catch(erro => console.log('Error launching dialer', erro));
        }

    }

    mapaopen(rotalat: number, rotalon: number) {

        //Sem Rotakm
        if (!rotalat || !rotalon) {
            this.util.toastSimply('Localização não informada!');
            return;
        }


        //Nao é celular nao abre mapa
        if (!this.util.nativeApp()) {
            this.util.open('https://www.google.com.br/maps/dir//' + rotalat + ',' + rotalon + '/@' + rotalat + ',' + rotalon + ',15z', '_blank');
            return;
        }


        // Register Login
        //let loading = this.util.loadingDots('Efetuando login...');
        //loading.present();

        //console.log(launchnavigator.availableApps(success, error););


        let options: LaunchNavigatorOptions = {start: 'London, ON', app: this.launchNavigator.APP.UBER};
        this.launchNavigator.navigate('Toronto, ON', options)
            .then(
                data => console.log('Launched navigator'),
                erro => console.log('Error launching navigator', erro)
            );

    }

    contatoBook(profile, contato) {

        //Nao é celular nao adiciona na agenda
        if (!this.util.nativeApp()) {
            this.util.toastSimply('Use no app para adicionar');
            return;
        }

        //Contato Adicionar
        let phoneSave = '0' + contato.ContatoUser;

        var options = new ContactFindOptions();
        options.hasPhoneNumber = true;
        options.filter = phoneSave;
        options.multiple = true;

        //Contato Find
        this.contacts.find(['phoneNumbers'], options)
            .then(data => {

                console.log('FINDED:', JSON.stringify(data));


                //Contato Existente
                if (data == null || data.length || contato._contatoSaved) {

                    contato._contatoSaved = true;

                    this.util.toastSimply('Contato já existe no seu celular', 4000);
                    return;

                }


                //Contato Save
                let contact: Contact = this.contacts.create();
                contact.name = new ContactName(null, this.util.nomeLast(profile.ProfileShow), this.util.nomeFirst(profile.ProfileShow));
                contact.phoneNumbers = [new ContactField('mobile', phoneSave)];
                contact.note = 'Lorean - Contatinho';
                contact.save().then(
                    () => {

                        contato._contatoSaved = true;
                        this.util.toastSimply('Adicionado aos seus contatos', 4000);

                    },

                    (error: any) => console.error('Error saving contact.', error)
                );

                //EXEMPLO RETORNO
                //{"_objectInstance": {"id":1665,
                //                    "rawId":null,
                //                    "displayName":null,
                //                    "name":{"givenName":"Mazao","honorificSuffix":"","formatted":"Mazao Flag","middleName":"","familyName":"Flag","honorificPrefix":""},
                //                    "nickname":"",
                //                    "phoneNumbers":[{"value":"+55 14 99635‑0042","pref":false,"id":0,"type":"mobile"}],
                //                    "emails":null,
                //                    "addresses":null,
                //                    "ims":null,
                //                    "organizations":[{"pref":"false","title":"","name":"","department":"","type":null}],
                //                    "birthday":null,
                //                    "note":"",
                //                    "photos":null,
                //                    "categories":null,
                //                    "urls":null},
                //  "rawId":null
                //}



                //data.map((contato) => {
                //    contato['_objectInstance'].phoneNumbers.map((phone) => {
                //        console.log(JSON.stringify(phone.value));
                //        if (phone.value == phoneSave) {
                //            console.log('ACHOUUUU', contato['_objectInstance'].name.givenName);
                //        }
                //    });
                //});


            });

    }






    friendy(event: any, action: TAction, profile: any): Observable<any> {

        return Observable.create((observer: Observer<any>) => {

            //Inverte para enviar o click contrário
            let followup: number;
            if (action == TAction.acMigo) followup = (profile.FriendyMigo == TFollowup.fwNenhum ? TFollowup.fwSeguidor : TFollowup.fwNenhum);
            if (action == TAction.acLock) followup = (profile.FriendyMigo == TFollowup.fwInimigo ? TFollowup.fwNenhum : TFollowup.fwInimigo);

            let loading = this.util.loadingDots();
            loading.present();

            this.profileService.friendy(action, profile.ProfileID, 0, followup)
                .finally(() => loading.dismiss())
                .subscribe(data => {

                    let follback = profile.FriendyMigo;
                    let follqtde = profile.FriendyQtde + (followup == TFollowup.fwSeguidor ? 1 : (follback == TFollowup.fwSeguidor ? -1 : 0));

                    profile.FriendyMigo = followup;
                    profile.FriendyQtde = follqtde;

                    this.messageService.get('friendy.edit').next({Profile: profile});

                    let qtde = (followup == TFollowup.fwInimigo ? 1 : (follback == TFollowup.fwInimigo ? -1 : 0));
                    if (qtde != 0) this.logadoService.inimigoQtds(qtde);

                    observer.next(data);
                    observer.complete();

                }, erro => {

                    this.util.alertResult(erro);

                    observer.error(erro);
                    observer.complete();

                });

        });

    }


    subscribeFollowupChanged(sender): Observable<any> {

        return Observable.create((observer: Observer<any>) => {

            this.messageService.get('friendy.edit')
                .subscribe(data => {

                    let array: any[] = (sender instanceof Array) ? sender : [sender];
                    let finded = array.find(PE => (PE.ProfileID == data.ProfileID));

                    let isArray = (sender instanceof Array);
                    if (isArray)  finded = sender.find(profile => (profile.Profile.ProfileID == data.Profile.ProfileID));

                    if (finded) {
                        finded.FriendyMigo = data.Profile.FriendyMigo;
                        finded.FriendyQtde = data.Profile.FriendyQtde;
                    }

                    observer.next(data);
                    observer.complete();

                }, erro => {

                    observer.error(erro);
                    observer.complete();

                });

        });

    }



    emissorFlug(profile: any, tipo: 'bool' | 'tint' | 'text' | 'info' | 'main') {

        let emissorHoje = this.util.dateHoje();
        let emissorDate = this.util.strToDate(profile.EmissorDate);

        if (tipo == 'bool') {
            return (profile.EmissorCert64 || (emissorDate && emissorDate >= emissorHoje));
        }

        if (tipo == 'tint') {
            if (profile.EmissorCert64) return 'CorWhat';
            if (!emissorDate) return 'CorText';
            if (emissorDate < emissorHoje) return 'CorFood';
            return 'CorWhat';
        }

        if (tipo == 'text') {
            if (profile.EmissorCert64) return 'certificado';
            if (!emissorDate) return 'selecione o';
            if (emissorDate < emissorHoje) return 'certificado';
            return 'expira em';
        }

        if (tipo == 'info') {
            if (profile.EmissorCert64) return 'carregado';
            if (!emissorDate) return 'certificado';
            if (emissorDate < emissorHoje) return 'expirado';
            return this.util.dataft(profile.EmissorDate);
        }

        if (tipo == 'main') {
            if (!emissorDate) return 'selecione';
            if (emissorDate < emissorHoje) return 'expirado';
            return 'Expira ' + this.util.dataft(profile.EmissorDate, 'dd', 'char', null);
        }

    }

    emissorSite(addresss: any, open: 'PF-FIND' | 'PJ-FIND' | 'IE-FIND' | 'UF-NFC') {

        let link = '';
        if (open == 'IE-FIND') link = 'https://dfe-portal.svrs.rs.gov.br/Nfe/Ccc';
        if (open == 'PJ-FIND') link = 'https://servicos.receita.fazenda.gov.br/servicos/cnpjreva/cnpjreva_solicitacao.asp';
        if (open == 'PF-FIND') link = 'https://servicos.receita.fazenda.gov.br/servicos/cpf/consultasituacao/consultapublica.asp';

        let site = '';
        if (open == 'UF-NFC') site = (addresss && addresss[0] ? addresss[0].Zipcity.ZipcityZone : 'XX') + '-NFC';
        //LINKS-ABAIXO OBTIDO EM ~> https://nfe.io/blog/nota-fiscal/o-que-e-csc

        if (site == 'AC-NFC')  link = 'http://www.sefaznet.ac.gov.br/sefazonline/servlet/principal';
        if (site == 'AL-NFC')  link = 'http://www.sefaz.al.gov.br/nfce/nfce-credenciamento';
        if (site == 'AP-NFC')  link = 'http://www.sefaz.ap.gov.br/sate';
        if (site == 'AM-NFC')  link = 'http://www.sefaz.am.gov.br';
        if (site == 'BA-NFC')  link = 'http://www.sefaz.ba.gov.br/especiais/como_se_tornar_emissor_nfce.html';
        if (site == 'DF-NFC')  link = 'http://dec.fazenda.df.gov.br/TransacaoCredenciamento.aspx';
        if (site == 'ES-NFC')  link = 'https://internet.sefaz.es.gov.br/informacoes/nfcEletronica/credenciamento.php';
        if (site == 'GO-NFC')  link = 'http://www.nfe.go.gov.br/';
        if (site == 'MA-NFC')  link = 'https://sistemas.sefaz.ma.gov.br/sefaznet/login.do?method=prepareLogin';
        if (site == 'MT-NFC')  link = 'https://homologacao.sefaz.mt.gov.br/nfce/codigosegurancactbn/ViewCadastroPublicoCSC.jsp';
        if (site == 'MS-NFC')  link = 'http://www.dfe.ms.gov.br/nfce-credenciamento/index.jsf';
        if (site == 'MG-NFC')  link = 'http://www.sped.fazenda.mg.gov.br/spedmg/nfce/credenciamento';
        if (site == 'PA-NFC')  link = 'http://nfce.sefa.pa.gov.br';
        if (site == 'PB-NFC')  link = 'https://www.receita.pb.gov.br';
        if (site == 'PR-NFC')  link = 'https://receita.pr.gov.br/login';
        if (site == 'PE-NFC')  link = 'https://www.sefaz.pe.gov.br/SitePages/Home.aspx';
        if (site == 'PI-NFC')  link = 'nfce@sefaz.pi.gov.br';
        if (site == 'RJ-NFC')  link = 'http://www4.fazenda.rj.gov.br/sefaz-dfe-csc/paginas/identificacao.jsf';
        if (site == 'RN-NFC')  link = 'http://www.set.rn.gov.br/contentProducao/aplicacao/set_v2/nfce/gerados/credenciamentos.asp';
        if (site == 'RS-NFC')  link = 'https://www.sefaz.rs.gov.br/Site/MontaMenu.aspx?MenuAlias=m_nfe_nfce';
        if (site == 'RO-NFC')  link = 'https://det.sefin.ro.gov.br';
        if (site == 'RR-NFC')  link = 'https://portalapp.sefaz.rr.gov.br/nfce/servlet/wp_login';
        if (site == 'SP-NFC')  link = 'http://www.nfce.fazenda.sp.gov.br/NFCePortal';
        if (site == 'SE-NFC')  link = 'http://www.nfce.se.gov.br/portal/index.jsp';
        if (site == 'TO-NFC')  link = 'http://www.sefaz.to.gov.br/nfce/login.jsf';
        if (site == 'SC-NFC')  link = 'https://sat.sef.sc.gov.br';

        this.util.open(link, '_blank', '');

    }



}



// WEBPACK FOOTER //
// ./src/repositories/profile-repository.ts